import repository from "@/repository/track-visit/index";

export default {
    async getPatientData({commit}, patient_id) {
        const {data} = await repository.getPatientData({patient_id})
        commit('SET_PATIENT_DATA', data);
    }
}
